// extracted by mini-css-extract-plugin
export var attachButton = "_kb-8";
export var sendButton = "_kb-2";
export var sendDisabled = "_kb-4";
export var sendEnabled = "_kb-3";
export var sendIcon = "_kb-6";
export var sendIconDisabled = "_kb-7";
export var sendStreaming = "_kb-5";
export var textarea = "_kb-1";
export var wrapper = "_kb-0";